// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"40":"css/axxentgroep","515":"css/axxent","615":"css/pdf","826":"css/dutchdays"}[chunkId] + ".css";
};